import useTranslations from '@/i18n/useTranslations';

export default function MuseumLabelContent({ label, closeButton = null, titleId }) {
  const t = useTranslations('common.shared.artwork_view.room_view');
  const artistDates = label.artistBirthYear && label.artistDeathYear
    ? `${label.artistBirthYear}–${label.artistDeathYear}`
    : label.artistBirthYear
      ? t('museum_label_born', { year: label.artistBirthYear })
      : label.artistDeathYear
        ? t('museum_label_died', { year: label.artistDeathYear })
        : null;

  return (
    <>
      <div className="museum-label-card__heading">
        <div className="museum-label-card__header">
          {label.artist ? (
            <p className="museum-label-card__artist">
              {label.artist}
              {artistDates ? <span className="museum-label-card__artist-dates">, {artistDates}</span> : null}
            </p>
          ) : null}
          {closeButton}
        </div>
        <h2 id={titleId} className="museum-label-card__title">
          <cite>{label.title}</cite>
          {label.year ? <span className="museum-label-card__title-year">, {label.year}</span> : null}
        </h2>
      </div>
      {label.dimensions ? <p className="museum-label-card__meta">{label.dimensions}</p> : null}
      {label.editionCount ? (
        <p className="museum-label-card__meta">
          {t('museum_label_edition_of', { count: label.editionCount })}
        </p>
      ) : null}
    </>
  );
}
